import { type Statut, StatutLibelle } from '../shared/Statut'

// TT: uniquement SaisieAdherent et EnCoursDeTransmission
export type StatutAdherent = Extract<Statut, 'SaisieAdherent' | 'EnCoursDeTransmission'>

export const StatutAdherentLibelle: Record<StatutAdherent, string> = {
  SaisieAdherent: StatutLibelle.SaisieAdherent,
  EnCoursDeTransmission: StatutLibelle.EnCoursDeTransmission,
}
